import React from 'react';
import './PageHero.css';

interface PageHeroProps {
  image: string;
  imageAlt?: string;
  tag?: string;
  heading: string;
  subheading?: string;
}

export const PageHero: React.FC<PageHeroProps> = ({ image, imageAlt = '', tag, heading, subheading }) => (
  <section className="rn-page-hero">
    <div className="rn-page-hero__bg" style={{ backgroundImage: `url(${image})` }} aria-hidden="true" />
    <div className="rn-page-hero__overlay" aria-hidden="true" />
    <div className="rn-page-hero__content">
      {tag && <span className="rn-page-hero__tag">{tag}</span>}
      <h1 className="rn-page-hero__heading">{heading}</h1>
      {subheading && <p className="rn-page-hero__sub">{subheading}</p>}
    </div>
  </section>
);
